import { useTranslation } from 'react-i18next';
import useSWR from 'swr';

import { IUserInfo } from '../../olist-types/UserInfo';
import { WhoAmIResponse } from '../../olist-types/whoAmI';
import { WHO_AM_I_URL } from '../utils/api-urls';
import fetcher from '../utils/fetcher';

const SWR_PERSONAL_DATA_OPTIONS = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  shouldRetryOnError: false,
};

const useUserInfo = (url: string = WHO_AM_I_URL): IUserInfo => {
  const { t } = useTranslation();

  const { data } = useSWR<WhoAmIResponse>(url, fetcher, SWR_PERSONAL_DATA_OPTIONS);

  const fallbackDisplayName = t`Seller`;

  return {
    blockedReason: data?.blocked_reason,
    createdAt: data?.created_at,
    documentNumber: data?.document_number,
    displayName: data?.display_name || fallbackDisplayName,
    email: data?.email,
    id: data?.id,
    isAdmin: data?.is_admin,
    lastLogin: data?.last_login,
    leadId: data?.lead_id,
    permissions: data?.permissions,
    name: data?.name,
    planType: data?.plan_type,
    signupOrigin: data?.signup_origin,
    subscriptionStatus: data?.subscription_status,
    userStatus: data?.user_status,
    termsOfUseVersion: data?.terms_of_use_version,
  };
};

export default useUserInfo;
